// extracted by mini-css-extract-plugin
export var allBooksIcon = "index-module--allBooksIcon--ghO65";
export var allBooksLink = "index-module--allBooksLink--LLkOw";
export var banner = "index-module--banner--iPxWs";
export var book = "index-module--book--kuYVI";
export var bookPrice = "index-module--bookPrice--7PfJK";
export var caption = "index-module--caption--LFCOO";
export var collection = "index-module--collection--MIhl8";
export var collectionContainer = "index-module--collectionContainer--C4HYF";
export var container = "index-module--container--bQ1Yf";
export var content = "index-module--content--J6uC1";
export var heading = "index-module--heading--lKRkp";
export var hero = "index-module--hero--H3B4s";
export var image = "index-module--image--5J2IG";
export var imageContainer = "index-module--imageContainer--v7RtC";
export var tocome = "index-module--tocome--EMGZO";
export var tocomeText = "index-module--tocomeText--nlySN";
export var tocomeTitle = "index-module--tocomeTitle--qO5kg";